<div>
  Service request items unread.
  <a (click)="action()">Undo</a>
</div>
<button (click)="close()">
  <i class="xos-icon icon-close-white"></i>
</button>
